// @flow
import $ from 'jquery';
import 'bootstrap';
import 'jquery-validation';
import 'daterangepicker';
import '../application/utils/extendedValidation';
import dayjs from 'dayjs';
import ahoy from 'ahoy.js';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import flashMessage from '../application/utils/flashMessage';
import {
  renderView,
  clearView,
  getViewClass,
  loadView,
} from '../application/utils/renderView';
import '../config/sentry';

window.jQuery = $;
window.$ = $;

window.render = renderView;
window.renderView = renderView;
window.clearView = clearView;
window.getViewClass = getViewClass;
window.loadView = loadView;

require('bootstrap-notify');
require('jquery-mask-plugin');

require('rails-ujs').start();
require('activestorage').start();

require('summernote/dist/summernote-bs4');
require('summernote/lang/summernote-ja-JP');

require('../application/forms/auto-floating-labels-form');

ahoy.configure({ startOnReady: false });
window.ahoy = ahoy;
window.notify = flashMessage;
window.dayjs = dayjs;

window.views = {
  layouts: {
    AlertView: require('../application/views/layouts/AlertView').default,
    ApplicationView: require('../application/views/layouts/ApplicationView')
      .default,
    LandingPageView: require('../application/views/layouts/LandingPageView')
      .default,
  },
  common: {
    table: require('../application/views/common/table').default,
    SquareTable: require('../application/views/common/SquareTable').default,
    NotificationView: require('../application/views/common/NotificationView')
      .default,
    NotificationSettingView: require('../application/views/common/NotificationSettingView')
      .default,
    SimulationPopupView: require('../application/views/common/SimulationPopupView')
      .default,
    PdfPreviewerV2: require('../application/views/common/PdfPreviewerV2')
      .default,
    headerDropdown: require('../application/views/common/HeaderDropdown')
      .default,
    headerScrollView: require('../application/views/common/HeaderScrollView')
      .default,
    SimpleFormView: require('../application/views/common/SimpleFormView')
      .default,
  },
  errors: {
    NotFoundPageView: require('../application/views/errors/NotFoundPageView')
      .default,
  },
  components: {
    v2: {
      forms: {
        Form1View: require('../application/views/components/v2/forms/Form1View')
          .default,
        Form2View: require('../application/views/components/v2/forms/Form2View')
          .default,
        Form3View: require('../application/views/components/v2/forms/Form3View')
          .default,
      },
    },
  },
  user: {
    passwords: {
      ChangePasswordForm: require('../application/views/user/passwords/ChangePasswordForm')
        .default,
    },
    settings: {
      FormView: require('../application/views/user/settings/FormView').default,
      ShowFormView: require('../application/views/user/settings/ShowFormView')
        .default,
      SettingFormView: require('../application/views/user/settings/SettingFormView')
        .default,
    },
    usages: {
      ShowView: require('../application/views/user/usages/ShowView').default,
    },
    ir_requests: {
      EditView: require('../application/views/user/ir_requests/EditView')
        .default,
    },
  },
  users: {
    confirmations: {
      ConfirmationFormView: require('../application/views/users/confirmations/ConfirmationFormView')
        .default,
    },
    passwords: {
      ForgetPasswordFormView: require('../application/views/users/passwords/ForgetPasswordFormView')
        .default,
      ResetPasswordFormView: require('../application/views/users/passwords/ResetPasswordFormView')
        .default,
    },
    sessions: {
      LoginFormView: require('../application/views/users/sessions/LoginFormView')
        .default,
    },
    two_factor_authentications: {
      FormView: require('../application/views/users/two_factor_authentications/FormView')
        .default,
    },
    FormView: require('../application/views/users/FormView').default,
    invitations: {
      FormView: require('../application/views/users/invitations/FormView')
        .default,
    },
  },
  corporates: {
    ListView: require('../application/views/corporates/ListView').default,
    ShowView: require('../application/views/corporates/ShowView').default,
  },
  investors: {
    ShowView: require('../application/views/investors/ShowView').default,
  },
  companies: {
    documents: {
      ListView: require('../application/views/companies/documents/ListView')
        .default,
    },
    news: {
      ListView: require('../application/views/companies/news/ListView').default,
    },
    stakeholder_electro_sign_requests: {
      electro_contracts: {
        IndexView: require('../application/views/companies/stakeholder_electro_sign_requests/electro_contracts/IndexView')
          .default,
      },
      electro_contract_files: {
        PreviewView: require('../application/views/companies/stakeholder_electro_sign_requests/electro_contract_files/PreviewView')
          .default,
      },
    },
    stockholder_meetings: {
      delegates: {
        EditView: require('../application/views/companies/stockholder_meetings/delegates/EditView')
          .default,
      },
    },
    important_meetings: {
      ShowView: require('../application/views/companies/important_meetings/ShowView')
        .default,
    },
  },
  company: {
    homes: {
      ShowView: require('../application/views/company/homes/ShowView').default,
    },
    purpose_id_of_personalizations: {
      ShowView: require('../application/views/company/purpose_id_of_personalizations/ShowView')
        .default,
    },
    growth_stages: {
      FormView: require('../application/views/company/growth_stages/FormView')
        .default,
    },
    members: {
      FormView: require('../application/views/company/members/FormView')
        .default,
    },
    capital_event_splits: {
      FormView: require('../application/views/company/capital_event_splits/FormView')
        .default,
    },
    capital_policies: {
      FormView: require('../application/views/company/capital_policies/FormView')
        .default,
    },
    capital_increase_rounds: {
      ConfirmationView: require('../application/views/company/capital_increase_rounds/ConfirmationView')
        .default,
      NewView: require('../application/views/company/capital_increase_rounds/NewView')
        .default,
    },
    documents: {
      ListView: require('../application/views/company/documents/ListView')
        .default,
      reviews: {
        ShowView: require('../application/views/company/documents/reviews/ShowView')
          .default,
        FormView: require('../application/views/company/documents/reviews/FormView')
          .default,
        ReviewerModal: require('../application/views/company/documents/reviews/ReviewerModal')
          .default,
        NoReviewerModal: require('../application/views/company/documents/reviews/NoReviewerModal')
          .default,
      },
    },
    investor_document_groups: {
      ShareGroupLink: require('../application/views/company/investor_document_groups/ShareGroupLink')
        .default,
      capital_policies: {
        FormView: require('../application/views/company/investor_document_groups/capital_policies/FormView')
          .default,
      },
      videos: {
        FormView: require('../application/views/company/investor_document_groups/videos/FormView')
          .default,
      },
    },
    important_meetings: {
      FormView: require('../application/views/company/important_meetings/FormView')
        .default,
      ShowView: require('../application/views/company/important_meetings/ShowView')
        .default,
      IndexView: require('../application/views/company/important_meetings/IndexView')
        .default,
    },
    director_meetings: {
      ReportView: require('../application/views/company/director_meetings/ReportView')
        .default,
      ResolutionView: require('../application/views/company/director_meetings/ResolutionView')
        .default,
      FormView: require('../application/views/company/director_meetings/FormView')
        .default,
      ShowView: require('../application/views/company/director_meetings/ShowView')
        .default,
      IndexView: require('../application/views/company/director_meetings/IndexView')
        .default,
      directors: {
        EditView: require('../application/views/company/director_meetings/directors/EditView')
          .default,
      },
      selected_attendees: {
        EditView: require('../application/views/company/director_meetings/selected_attendees/EditView')
          .default,
      },
      minutes: {
        execute_signs: {
          CompleteView: require('../application/views/company/director_meetings/minutes/execute_signs/CompleteView')
            .default,
          FormView: require('../application/views/company/director_meetings/minutes/execute_signs/FormView')
            .default,
        },
        documents: {
          BasicInfoView: require('../application/views/company/director_meetings/minutes/documents/BasicInfoView')
            .default,
          JoinMemberView: require('../application/views/company/director_meetings/minutes/documents/JoinMemberView')
            .default,
          AbsentMembersView: require('../application/views/company/director_meetings/minutes/documents/AbsentMembersView')
            .default,
          ResolutionReportMinuteView: require('../application/views/company/director_meetings/minutes/documents/ResolutionReportMinuteView')
            .default,
        },
      },
    },
    ir_requests: {
      ListView: require('../application/views/company/ir_requests/ListView')
        .default,
    },
    irs: {
      common: {
        ActiveTabChanger: require('../application/views/company/irs/common/ActiveTabChanger')
          .default,
        ShowAllDisclaimer: require('../application/views/company/irs/common/ShowAllDisclaimer')
          .default,
      },
      reports: {
        FormView: require('../application/views/company/irs/reports/FormView')
          .default,
        NewView: require('../application/views/company/irs/reports/NewView')
          .default,
      },
    },
    establish_rounds: {
      FormView: require('../application/views/company/establish_rounds/FormView')
        .default,
    },
    capital_event_rounds: {
      FormView: require('../application/views/company/capital_event_rounds/FormView')
        .default,
    },
    right_strike: {
      SelectSharesView: require('../application/views/company/right_strike/SelectSharesView')
        .default,
      SelectMembersView: require('../application/views/company/right_strike/SelectMembersView')
        .default,
      ConfirmView: require('../application/views/company/right_strike/ConfirmView')
        .default,
    },
    rightholders: {
      FormView: require('../application/views/company/rightholders/FormView')
        .default,
      IndexView: require('../application/views/company/rightholders/IndexView')
        .default,
      NewView: require('../application/views/company/rightholders/NewView')
        .default,
      ConvertibleEquityView: require('../application/views/company/rightholders/ConvertibleEquityView')
        .default,
    },
    stockholder_meetings: {
      IndexView: require('../application/views/company/stockholder_meetings/IndexView')
        .default,
      ShowView: require('../application/views/company/stockholder_meetings/ShowView')
        .default,
      ReportView: require('../application/views/company/stockholder_meetings/ReportView')
        .default,
      FormView: require('../application/views/company/stockholder_meetings/FormView')
        .default,
      MinuteView: require('../application/views/company/stockholder_meetings/MinuteView')
        .default,
      TypeSelectView: require('../application/views/company/stockholder_meetings/TypeSelectView')
        .default,
      resolution_reports: {
        stockholders: {
          ConfirmView: require('../application/views/company/stockholder_meetings/resolution_reports/stockholders/ConfirmView.js')
            .default,
          NewView: require('../application/views/company/stockholder_meetings/resolution_reports/stockholders/NewView')
            .default,
        },
      },
      stockholders: {
        ConfirmView: require('../application/views/company/stockholder_meetings/stockholders/ConfirmView.js')
          .default,
        EnConfirmView: require('../application/views/company/stockholder_meetings/stockholders/EnConfirmView.js')
          .default,
        NewView: require('../application/views/company/stockholder_meetings/stockholders/NewView')
          .default,
        EnNewView: require('../application/views/company/stockholder_meetings/stockholders/EnNewView')
          .default,
        FormView: require('../application/views/company/stockholder_meetings/stockholders/FormView')
          .default,
      },
    },
    rights: {
      FormView: require('../application/views/company/rights/FormView').default,
    },

    stockholders: {
      IndexView: require('../application/views/company/stockholders/IndexView')
        .default,
      FormView: require('../application/views/company/stockholders/FormView')
        .default,
      NewView: require('../application/views/company/stockholders/NewView')
        .default,
      DeleteView: require('../application/views/company/stockholders/DeleteView')
        .default,
      CsvImportView: require('../application/views/company/stockholders/CsvImportView')
        .default,
      newly_transfer_stakeholders: {
        NewView: require('../application/views/company/stockholders/newly_transfer_stakeholders/NewView')
          .default,
      },
      stock_transfers: {
        FormView: require('../application/views/company/stockholders/stock_transfers/FormView')
          .default,
        IndexView: require('../application/views/company/stockholders/stock_transfers/IndexView')
          .default,
      },
      treasury_stock_cancels: {
        FormView: require('../application/views/company/stockholders/treasury_stock_cancels/FormView')
          .default,
      },
      permissions: {
        FormView: require('../application/views/company/stockholders/permissions/FormView.js')
          .default,
      },
    },
    tutorial: {
      FormView: require('../application/views/company/tutorial/FormView')
        .default,
    },
    uploadfiles: {
      FormView: require('../application/views/company/uploadfiles/FormView')
        .default,
    },
    kpis: {
      FormView: require('../application/views/company/kpis/FormView').default,
      MultipleFileFormView: require('../application/views/company/kpis/MultipleFileFormView')
        .default,
      departments: {
        FormView: require('../application/views/company/kpis/departments/FormView')
          .default,
      },
    },
    financials: {
      IndexView: require('../application/views/company/financials/IndexView')
        .default,
    },
    initial_settings: {
      ShowView: require('../application/views/company/initial_settings/ShowView')
        .default,
    },
    settings: {
      basics: {
        ShowView: require('../application/views/company/settings/basics/ShowView')
          .default,
      },
      plan_types: {
        FormView: require('../application/views/company/settings/plan_types/FormView')
          .default,
      },
    },
    matchings: {
      settings: {
        IssueView: require('../application/views/company/matchings/settings/IssueView')
          .default,
        PreviewModalView: require('../application/views/company/matchings/settings/PreviewModalView')
          .default,
        FormView: require('../application/views/company/matchings/settings/FormView')
          .default,
      },
      investors: {
        ShowView: require('../application/views/company/matchings/investors/ShowView')
          .default,
      },
    },
    stockholder_lists: {
      FormListView: require('../application/views/company/stockholder_lists/FormListView')
        .default,
    },
    funding_rounds: {
      FormView: require('../application/views/company/funding_rounds/FormView')
        .default,
    },
    subsidy_rounds: {
      FormView: require('../application/views/company/subsidy_rounds/FormView')
        .default,
    },
    procedures: {
      FormView: require('../application/views/company/procedures/FormView')
        .default,
      StockOptionInput: require('../application/views/company/procedures/StockOptionInput')
        .default,
      StockOptionConfirm: require('../application/views/company/procedures/StockOptionConfirm')
        .default,
      Notification: require('../application/views/company/procedures/Notification')
        .default,
      SelectCapitalIncreaseMethodView: require('../application/views/company/procedures/SelectCapitalIncreaseMethodView')
        .default,
    },
    stock_options: {
      issuances: {
        basic_informations: {
          FormView: require('../application/views/company/stock_options/issuances/basic_informations/FormView')
            .default,
        },
        term_and_conditions: {
          FormView: require('../application/views/company/stock_options/issuances/term_and_conditions/FormView')
            .default,
        },
        agreement_uploaders: {
          FormView: require('../application/views/company/stock_options/issuances/agreement_uploaders/FormView')
            .default,
        },
      },
      modal: {
        IndexView: require('../application/views/company/stock_options/modal/IndexView')
          .default,
        SoIndexView: require('../application/views/company/stock_options/modal/SoIndexView')
          .default,
      },
      rightholders: {
        modal: {
          FormView: require('../application/views/company/stock_options/rightholders/modal/FormView')
            .default,
        },
        shares: {
          registration_methods: {
            FormView: require('../application/views/company/stock_options/rightholders/shares/registration_methods/FormView')
              .default,
          },
          basic_informations: {
            FormView: require('../application/views/company/stock_options/rightholders/shares/basic_informations/FormView')
              .default,
          },
          attribute_informations: {
            FormView: require('../application/views/company/stock_options/rightholders/shares/attribute_informations/FormView')
              .default,
          },
        },
        csv_imports: {
          CsvImportView: require('../application/views/company/stock_options/rightholders/csv_imports/CsvImportView')
            .default,
        },
        change_owners: {
          name_change_reasons: {
            NewView: require('../application/views/company/stock_options/rightholders/change_owners/name_change_reasons/NewView')
              .default,
          },
          registration_methods: {
            NewView: require('../application/views/company/stock_options/rightholders/change_owners/registration_methods/NewView')
              .default,
          },
          basic_informations: {
            NewView: require('../application/views/company/stock_options/rightholders/change_owners/basic_informations/NewView')
              .default,
          },
          attribute_informations: {
            NewView: require('../application/views/company/stock_options/rightholders/change_owners/attribute_informations/NewView')
              .default,
          },
          grantor_informations: {
            NewView: require('../application/views/company/stock_options/rightholders/change_owners/grantor_informations/NewView')
              .default,
          },
        },
      },
    },
    electro_contracts: {
      IndexView: require('../application/views/company/electro_contracts/IndexView')
        .default,
    },
    fund_procurement_histories: {
      IndexView: require('../application/views/company/fund_procurement_histories/IndexView')
        .default,
    },
  },
  vc: {
    investees: {
      ChangeSelect: require('../application/views/vc/investees/ChangeSelect')
        .default,
      ChangeSearchInput: require('../application/views/vc/investees/ChangeSearchInput')
        .default,
      IndexView: require('../application/views/vc/investees/IndexView').default,
      infos: {
        InfoView: require('../application/views/vc/investees/infos/InfoView')
          .default,
        ShowView: require('../application/views/vc/investees/infos/ShowView')
          .default,
      },
      news: {
        ListView: require('../application/views/vc/investees/news/ListView')
          .default,
      },
      investment_managements: {
        InvestmentManagementView: require('../application/views/vc/investees/investment_managements/InvestmentManagementView')
          .default,
        InvestmentView: require('../application/views/vc/investees/investment_managements/InvestmentView')
          .default,
        InvestmentHistoryView: require('../application/views/vc/investees/investment_managements/InvestmentHistoryView')
          .default,
      },
      documents: {
        ListView: require('../application/views/vc/investees/documents/ListView')
          .default,
      },
      ir_requests: {
        reports: {
          NewView: require('../application/views/vc/investees/ir_requests/reports/NewView')
            .default,
          EditView: require('../application/views/vc/investees/ir_requests/reports/EditView')
            .default,
        },
        IndexView: require('../application/views/vc/investees/ir_requests/IndexView')
          .default,
      },
    },
    investee_wizard: {
      investee_steps: {
        FormView: require('../application/views/vc/investee_wizard/investee_steps/FormView')
          .default,
      },
      investment_steps: {
        FormView: require('../application/views/vc/investee_wizard/investment_steps/FormView')
          .default,
      },
    },
    settings: {
      basics: {
        ShowView: require('../application/views/vc/settings/basics/ShowView')
          .default,
      },
      funds: {
        IndexView: require('../application/views/vc/settings/funds/IndexView')
          .default,
        FormView: require('../application/views/vc/settings/funds/FormView')
          .default,
      },
      notices: {
        ShowView: require('../application/views/vc/settings/notices/ShowView')
          .default,
      },
    },
    members: {
      FormView: require('../application/views/vc/members/FormView').default,
    },
  },
  capital: {
    initial_settings: {
      FormView: require('../application/views/capital/initial_settings/FormView')
        .default,
    },
  },
  investor: {
    initial_settings: {
      FormView: require('../application/views/investor/initial_settings/FormView')
        .default,
    },
    matchings: {
      FormView: require('../application/views/investor/matchings/FormView')
        .default,
      initial_settings: {
        FormView: require('../application/views/investor/matchings/initial_settings/FormView')
          .default,
        PreviewModal: require('../application/views/investor/matchings/initial_settings/PreviewModal')
          .default,
      },
    },
    companies: {
      FormView: require('../application/views/investor/companies/FormView')
        .default,
      EditView: require('../application/views/investor/companies/EditView')
        .default,
    },
    connections: {
      IndexView: require('../application/views/investor/connections/IndexView')
        .default,
      matching: {
        entrepreneurs: {
          ShowView: require('../application/views/investor/connections/matching/entrepreneurs/ShowView')
            .default,
        },
      },
    },
  },
  white_paper: {
    download: {
      FormView: require('../application/views/white_paper/download/FormView')
        .default,
    },
  },
  contact: {
    FormView: require('../application/views/contact/FormView').default,
  },
};
